import AXIOS from "../config/http-common";

/**
 * Classe utilitaire pour l'appel des api, elle référencie toutes les url des services rest'
 *
 */
const apiService = {
  auth: {
    requestLink(email, rememberMe) {
      return AXIOS.post("/auth/request-link", { email, rememberMe });
    },
    verify(token) {
      return AXIOS.get(`/auth/verify?token=${token}`);
    },
    me() {
      return AXIOS.get("/auth/me");
    },
    logout() {
      return AXIOS.post("/auth/logout");
    },
  },
  projet: {
    findProjets() {
      return AXIOS.get("/projet/find_projets");
    },
    findProjet(projetId) {
      return AXIOS.get("/projet/find_projet/" + projetId);
    },
    createUpdate(projet) {
      return AXIOS.post("/projet/create_update", projet);
    },
    deleteProjet(projetId) {
      return AXIOS.delete("/projet/delete_projet/" + projetId);
    },
  },
  saisie: {
    findProjetSaisie(projetId) {
      return AXIOS.get("/saisie/find_saisie_projet/" + projetId);
    },
    findSaisies() {
      return AXIOS.get("/saisie/find_saisies");
    },
    findProjet(saisieId) {
      return AXIOS.get("/saisie/find_saisie/" + saisieId);
    },
    createUpdate(saisie) {
      return AXIOS.post("/saisie/create_update", saisie);
    },
    deleteSaisie(saisieId) {
      return AXIOS.delete("/saisie/delete_saisie/" + saisieId);
    },
    search(searchObject) {
      return AXIOS.post("/saisie/search_saisie", searchObject);
    },
    findYears() {
      return AXIOS.get("/saisie/saisie_years");
    },
    exportCSV(searchParam) {
      return AXIOS.post("/saisie/export_saisies", searchParam);
    },
  },
  referentiels: {
    findReferentielsTypes() {
      return AXIOS.get("/referentiels/find_referentiels_types");
    },
    createOrUpdateReferentiels(referentiel) {
      return AXIOS.post(
        "/referentiels/create_or_update_referentiels",
        referentiel
      );
    },
    findReferentiels() {
      return AXIOS.get("/referentiels/find_referentiels");
    },
    deleteReferentiel(referentiel) {
      return AXIOS.post("/referentiels/delete_referentiel/", referentiel);
    },
  },
  adherents: {
    createUpdate(adherent) {
      return AXIOS.post("/adherent/create_update", adherent);
    },
    findAdherents() {
      return AXIOS.get("/adherent/find_adherents");
    },
    findAdherentsByYear(year) {
      return AXIOS.get("/adherent/find_by_year/" + year);
    },
    findSimpleAdherents() {
      return AXIOS.get("/adherent/find_simple_adherents");
    },
    deleteOrDesactivateAdherent(adherentId) {
      return AXIOS.delete(
        "/adherent/delete_adherent_or_desactivate/" + adherentId
      );
    },
    findAdherent(adherentId) {
      return AXIOS.get("/adherent/find_adherent/" + adherentId);
    },

    findAdherentDon(adherentId) {
      return AXIOS.get("/adherent/adherent_don/" + adherentId);
    },
  },
  categories: {
    findCategories() {
      return AXIOS.get("/categorie/find_categories");
    },
  },
  devises: {
    findDevises() {
      return AXIOS.get("/devise/find_devises");
    },
  },
  modePaiement: {
    findModePaiement() {
      return AXIOS.get("/mode_paiement/find_mode_paiements");
    },
  },
  justificatifs: {
    uploadJustificatif(formData, saisieId) {
      return AXIOS.post(
        "/justificatif/upload_justificatif/" + saisieId,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    downloadJustificatif(justificatifId) {
      return AXIOS.get("/justificatif/downloadFile/" + justificatifId, {
        responseType: "blob",
      });
    },
  },
  recuFiscal: {
    findAllRecusFiscauxParam() {
      return AXIOS.get("/recu_fiscal/all");
    },
    findByYear(year) {
      return AXIOS.get("/recu_fiscal/find_by_year/" + year);
    },
    save(recuFiscalParam) {
      return AXIOS.post("/recu_fiscal/save", recuFiscalParam);
    },
    checkSaisieDon(year) {
      return AXIOS.get("/recu_fiscal/check/" + year);
    },
    createFiles(recuFiscalParam) {
      return AXIOS.post("/recu_fiscal/create_files", recuFiscalParam);
    },
    testEmail(sendRecuParam) {
      return AXIOS.post("/recu_fiscal/test_email", sendRecuParam);
    },
    telechargerRecuFiscal(recuFiscalId) {
      return AXIOS.get(`/recu_fiscal/telecharger/${recuFiscalId}`, {
        responseType: "blob",
      });
    },
    sendRecus(sendRecuParam) {
      return AXIOS.post("/recu_fiscal/send_recus", sendRecuParam);
    },
  },
};

export default apiService;
